<template>
  <div class = "DialogMask">
    <div class = "Dialog" :style="{ width: width, maxWidth: maxWidth }">
      <div class = "Head">
        <img :src = "icon" style = "width: 20px;">
        <span style = "padding-left: 10px; font-weight: 900;">{{ title }}</span>
      </div>
      <div class = "Body">
        <span v-if = "content != ''">{{ content }}</span>
        <slot></slot>
      </div>
      <div class = "ButtonGroup">
        <button v-if = "acceptName != ''" class = "ControlButton"
          style = "background: var(--ccs-primary-color); color: #fff; border: none;" @click = "accept">
          <span>{{ acceptName }}</span>
        </button>
        <button v-if = "cancelName != ''" class = "ControlButton"
          style = "margin-left: 10px; color: var(--ccs-primary-color); border: 1px solid var(--ccs-primary-color);"
          @click = "DialogCancel">
          <span>{{ cancelName }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: '提示' },
    content: { type: String, default: '' },
    acceptName: { type: String, default: '' },
    cancelName: { type: String, default: '' },
    icon: { type: String, default: '/icon/warning.svg' },
    accept: { type: Function },
    width: { type: String, default: 'auto' },
    maxWidth: { type: String, default: '400px' }
  },
  methods: {
    DialogCancel: function (event) {
      this.$emit('dialogCancel', event)
    }
  }
}
</script>

<style scoped>
  .DialogMask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--ccs-mask-background-color);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .Dialog {
    min-width: 300px;
    max-width: 400px;
    background: #ffffff;
    padding: 25px 30px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    color: var(--ccs-primary-font-color);
  }

  .Dialog .Head {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
  }

  .Dialog .ButtonGroup {
    padding-top: 20px;
    display: flex;
    justify-content: flex-end;
  }

  .Dialog .Body {
    font-size: 14px;
    line-height: 1.5;
  }
</style>